import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1afcb880&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1afcb880&prod&scoped=true&lang=css"
import style1 from "../lanhu_wenzhangxiangqing/assets/index.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afcb880",
  null
  
)

export default component.exports